import { matchStatusUpdate, setJumpBallClockNewSeconds, toggleShotClock } from '../reducers/playersReducer';
import store from '../store';

let jumpBallIntervalId = null;

export const startJumpBallClock = (initialSeconds) => {
  // Calculate the end time for the countdown
  const endTime = Date.now() + initialSeconds * 1000;

  const updateClock = () => {
    const remainingMilliseconds = endTime - Date.now();

    // If the countdown is finished, stop the timer and update state
    if (remainingMilliseconds <= 0) {
      clearInterval(jumpBallIntervalId);
      store.dispatch(setJumpBallClockNewSeconds(0));
      store.dispatch(toggleShotClock(false));
      return;
    }

    // Calculate the remaining time in seconds
    const remainingTime = remainingMilliseconds / 1000;
    let displayTime;

    // For 5 seconds or more, show whole seconds.
    // Below 5 seconds, display one decimal point.
    if (remainingTime >= 5) {
      displayTime = Math.ceil(remainingTime);
    } else {
      displayTime = remainingTime.toFixed(1);
    }

    store.dispatch(setJumpBallClockNewSeconds(parseFloat(displayTime)));
  };

  // Use a 100ms interval to ensure smooth updates
  jumpBallIntervalId = setInterval(updateClock, 100);
  store.dispatch(toggleShotClock(true));
};

export const stopJumpBallClock = () => {
  clearInterval(jumpBallIntervalId);
  store.dispatch(toggleShotClock(false));
};

export const resetJumpBallClock = () => {
  clearInterval(jumpBallIntervalId);
  store.dispatch(setJumpBallClockNewSeconds(24));
  store.dispatch(toggleShotClock(false));
};
